import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import * as _ from "lodash";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { connect } from "react-redux";
import {
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import SearchBar from "material-ui-search-bar";
import List from "@material-ui/core/List";

import Services from "../../api/api";
import { removeSpacetoLowerCase } from "../../api/helper";

import imgUrl from "../../assets/images/imageUrl.js";
import KnowYourRightsList from "./KnowYourRightsList";
import KnowYourRightsCard from "./KnowYourRightsCard";
import Loader from "../loaders/loader";

import { setSelectedComponentObject, resetSelectedCompnentObject } from "../../redux/actions/appActions";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  list: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

class KnowYourRights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      list: [],
      orignalList: [],
      isLoading: true,
      key: {},
      background: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.getKnowYourRightsDetail = this.getKnowYourRightsDetail.bind(this);
    this.cancelSearch = this.cancelSearch.bind(this);

  }
  // const classes = useStyles();
  // const theme = useTheme();
  // const [value, setValue] = React.useState(0);

  componentDidMount() {
    gaLogEvent("Know your rights", '', '');

    OffileDb.setDatabase()
    if (this.props.location.state) {
      this.setState({ isLoading: true, }, () => {
        this.getKnowYourRightsDetail(this.props.location.state.id);
      });
    } else if (Object.keys(this.props.selectedComponentObj).length != 0) {
      if (this.props.location.pathname == '/layout/knowyourrights') {
        if (this.props.selectedComponentObj.new && Object.keys(this.props.selectedComponentObj.new).length != 0) {
          this.getKnowYourRightsDetail(this.props.selectedComponentObj.new.id);
        } else {
          this.props.history.push("/layout");
        }
      } else {
        if (this.props.selectedComponentObj.new && Object.keys(this.props.selectedComponentObj.new).length != 0) {
          this.getKnowYourRightsDetail(this.props.selectedComponentObj.new.id);
        }
      }
    } else {
      this.props.history.push("/layout");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.state && nextProps.location.state.id) {
      this.getKnowYourRightsDetail(nextProps.location.state.id);
    } else if (Object.keys(nextProps.selectedComponentObj).length != 0) {
      if (nextProps.location.pathname == '/layout/knowyourrights') {
        if (this.props.selectedComponentObj.prev && this.props.selectedComponentObj.prev.id) {
          this.getKnowYourRightsDetail(nextProps.selectedComponentObj.prev.id);
        } else {
          this.getKnowYourRightsDetail(nextProps.selectedComponentObj.new.id);
        }
      } else {
        if (Object.keys(nextProps.selectedComponentObj.new).length != 0) {
          this.getKnowYourRightsDetail(nextProps.selectedComponentObj.new.id);
        }
      }
    }
  }

  componentWillUnmount() {
    // this.props.resetSelectedCompnentObject();
  }

  getKnowYourRightsDetail(contentid) {
    this.loadOfflineData(contentid)
  }

  loadApiData(contentid) {
    if (navigator.onLine) {
      let params = {
        communityId: this.props.communityuid,
        contentId: contentid,
        languageId: parseInt(this.props.langId),
        roleId: JSON.parse(localStorage.getItem("obj")).roleId,
        userId: JSON.parse(localStorage.getItem("obj")).userId,
      };
      Services.getRoleWiseContent(params).then((res) => {
        try{
          if (res.data.status == 200) {
            if (res.data.data.childs) {
              this.setState({
                list: res.data.data.childs,
                orignalList: res.data.data.childs,
                isLoading: false,
                background: res.data.data.contentList[0].backgroundImage
              });
              OffileDb.setData('KnowYourRightsDetail-'+contentid, res.data.data)

            }
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    }
  }


  loadOfflineData(contentid) {
    var that = this
    OffileDb.getData('KnowYourRightsDetail-'+contentid).then(function (result) {
      if (!result.status && result.status != 404) {
        that.setState({
          list: result.data.childs,
          orignalList: result.data.childs,
          isLoading: false,
        });
      } else {
        that.loadApiData(contentid)
      }
    });
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue,
    });
    // setValue(newValue);
  };

  handleChangeIndex = (index) => {
    // setValue(index);
    this.setState({
      value: index,
    });
  };

  handleOnSearch = (e) => {
    let topicList = _.cloneDeep(this.state.orignalList);
    let filtered = [];
    filtered = topicList.filter(function (str) {

      return (
        removeSpacetoLowerCase(str.contentName).indexOf(
          removeSpacetoLowerCase(e)
        ) !== -1
      );
    });

    if (e.length == 0) {
      filtered = _.cloneDeep(this.state.orignalList);
    }
    this.setState({
      list: filtered,
    });
  };

  cancelSearch(e) {
    this.setState({
      list: this.state.orignalList,
    });
  }


  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: `url(${this.state.background})` } : {};
    console.log(this.state.orignalList)
    return (
      <>
        <div className="gk-page homepagegrid-page getknowledge-page getknowledgeable_page" >
          {
            templateID == 1 && (
              <div className="backgroundivholder">
                <div className="bgdiv1">
                  <div class="welcometopcurve">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                      <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                    </svg>
                  </div>
                </div>
                <div className="bgdiv2"></div>
              </div>
            )
          }

          <div className="gridcontainer">
            <Grid container spacing={3} className="gridcontainer">
              <div className="text-center getknowledgepagemaindiv">
                <Grid item xs={12} className="gkdivcontent zero getknowledgepagemaindiv">
                  <AppBar position="static" color="default" style={colorStyles}>
                    <Tabs
                      value={this.state.value}
                      onChange={this.handleChange}
                      indicatorColor="primary"
                      textColor={templateID == 1 ? "primary" : "#fff"}
                      variant="fullWidth"
                      aria-label="full width tabs example"
                    >
                      <Tab label={t('Know Your Rights')} {...a11yProps(0)} />
                    </Tabs>
                  </AppBar>
                  <SwipeableViews
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={this.state.value}
                    onChangeIndex={this.handleChangeIndex}
                    className="infotabcontainer bg-know-your-rights overflowy_hidden" style={bgStyles}>
                    <TabPanel
                      class="know-your-rights-tab-content paddingfixes"
                      value={this.state.value}
                      index={0}
                      dir={theme.direction}
                    >
                      <div className="getknowledgetabsmainholder">
                        {this.state.isLoading ? (
                          <Loader isLoading={this.state.isLoading} />
                        ) : (
                          <>
                            <SearchBar
                              placeholder={t('Search')}
                              className="getaccess-searchbar"
                              onChange={this.handleOnSearch}
                              onCancelSearch={this.cancelSearch}
                            />
                            <div className={this.state.list.length == 0 ? "kyr-white-background" : ""}>
                              {this.state.list.length == 0 ? (
                                <strong><p>{t('No Data Found')}</p></strong>
                              ) : (
                                <List className="know-your-right-list">
                                  {this.state.list.map((kyr) => {
                                    return (
                                      templateID == 2 ? <KnowYourRightsList KnowYourRightsObj={kyr} /> : <KnowYourRightsCard KnowYourRightsObj={kyr} />
                                    );
                                  })}
                                </List>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </TabPanel>
                  </SwipeableViews>
                </Grid>
              </div>
            </Grid>
          </div>
        </div>
      </>
    );
  }
}

KnowYourRights.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
    selectedBottomComponentObj: storeState.bottomComponentObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transKnowYourRights = withTranslation()(KnowYourRights);
const ThemeKnowYourRights = withTheme(transKnowYourRights);
const FinalThemeKnowYourRights = withStyles(useStyles)(ThemeKnowYourRights);
const routeNewKnowledge = withRouter(FinalThemeKnowYourRights);
export default connect(mapStateToProps, { setSelectedComponentObject, resetSelectedCompnentObject })(
  routeNewKnowledge
);
